
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from "@mui/material";
import {getLanguage,useTranslation} from 'react-multi-lang'
interface iProps {open:boolean,onClose?:(event: {}
    , reason: "backdropClick" | "escapeKeyDown") => void,onConfirm:Function,handleClose:Function}

export function WarningConfirmDialog({ open, onClose, onConfirm ,handleClose}:iProps) {
    const t=useTranslation()
  return (
    <Dialog open={open} onClose={()=>handleClose()}>
      <DialogTitle color="warning">
       {
        getLanguage() ==='en'? 
        "Warning":'تحذير'
       }
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          {
            getLanguage()==='en'?
            'This action will delete the information you entered before , make sure to save it before proceeding!!':
            "متابعة هذا الاجراء سيفقدك المعلومات التي أدخلتها , هل أنت واثق من المتابعة ؟"
          }
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={()=>handleClose()}>
          {
            t('cancel')
          }
        </Button>
        <Button onClick={()=>{
            onConfirm()
            handleClose()
        }
    } color="warning" variant="contained">
          {
            t('continue')
          }
        </Button>
      </DialogActions>
    </Dialog>
  );
}
